import { render, staticRenderFns } from "./mhospital.vue?vue&type=template&id=0a47ea56&"
import script from "./mhospital.vue?vue&type=script&lang=js&"
export * from "./mhospital.vue?vue&type=script&lang=js&"
import style0 from "./mhospital.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports